import React, { useState } from "react";
import { Link } from "react-router-dom";
import { addFavorite, removeFavorite } from "../app/reducers/favouriteProduct";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faVideo,
  faVideoSlash,
  faPlayCircle,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";

const PropertyItem = ({ property, index }) => {
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);
  const favorites = useSelector((state) => state.favouriteproduct);

  const isFavorite = favorites.some(
    (favorite) => favorite._id === property._id
  );

  const toggleFavorite = (property) => {
    if (isFavorite) {
      console.log("removed from favourites");
      dispatch(removeFavorite(property._id));
    } else {
      dispatch(addFavorite(property));
      console.log("added to favourites");
    }
  };

  return (
    <div
      className="max-w-[350px] xl:min-w-[300px] xl:max-w-[350px] group w-full   bg-[#fefefe
] shadow-md rounded-[5px] mx-auto hover:shadow-2xl cursor-pointer transition-all duration-300 ease-in-out"
      key={index}
    >
      <div className="   relative overflow-hidden rounded-t-[5px]">
        <Link to={`/listing/${property._id}`}>
          <div className="w-[350px] h-[200px] overflow-hidden">
            {/* {imageLoaded && ( */}
            {!imageLoaded && (
              <div className="w-full h-full object-cover object-center flex justify-center items-center">
                <img
                  src="/assets/loader/loader.png"
                  alt=""
                  className="flex justify-center items-center w-full max-w-[30px]"
                />
              </div>
            )}
            <img
              // src={property?.image}
              src={property.imageUrls[0]}
              alt="Image"
              onLoad={() => setImageLoaded(true)}
              className="w-full h-full object-cover object-center"
            />
            {/* )} */}
          </div>
        </Link>

        <div className=" absolute right-2 bottom-2 bg-[#009932]/75 rounded-[4px] text-white px-[4px] py-1 flex justify-center items-center cursor-pointer text-[12px]">
          Rs: {property?.regularPrice}
        </div>
        <div className=" absolute left-2 bottom-2 bg-[#d45941]/75 rounded-[4px] text-white px-2 py-1 flex justify-center items-center cursor-pointer text-[12px] uppercase">
          {property?.type}
        </div>
      </div>
      <div className="py-4 flex flex-col justify-between items-center gap-1">
        <div className="flex w-full justify-between items-center px-4">
          {/* <div className="text-[12px] flex justify-center items-center bg-[#b27363] p-[4px] rounded-md"> */}
          <a href="https://www.youtube.com/shorts/JvcY4Rp3QAs" target="_blank">
            <FontAwesomeIcon
              icon={faPlayCircle}
              size="sm"
              style={{ color: "#1f2937" }}
              className="px-1 text-[12px]"
            />
          </a>
          <div>
            <p className="text-center  w-full mx-auto text-[#abaaaa] text-[10px]">
              <span className="px-[2px]">
                {property?.bedrooms} bed & {property?.bathrooms} bath
              </span>{" "}
              |{" "}
              <span className="px-[2px]">
                {property?.furnished ? "furnished" : "unfurnished"}
              </span>{" "}
              |{" "}
              <span className="px-[2px]">
                {property?.parking ? "parking" : "noparking"}
              </span>
            </p>
          </div>
          <FontAwesomeIcon
            icon={faHeart}
            size="sm"
            style={{ color: isFavorite ? "green" : "#1f2937" }}
            className="px-1 text-[12px]"
            onClick={() => toggleFavorite(property)}
          />
        </div>

        {/* {property.features.map((feature, featureIndex) => (
    <li key={featureIndex} className="list-none ">
      {feature}
    </li>
  ))} */}
        <p className="font-normal text-[12px] text-center text-wrap line-clamp-2 px-1">
          {property?.name}
        </p>
      </div>
    </div>
  );
};

export default PropertyItem;
